import { hasMany, belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { memberAction, collectionAction } from "ember-api-actions";

export default ShModel.extend({
  name: attr('string'),
  title: readOnly('name'),
  lastBuyerMessagePreview: attr('string'),
  lastBuyerMessageAt: attr('date'),
  lastSellerMessagePreview: attr('string'),
  lastSellerMessageAt: attr('date'),
  createdAt: attr('date'),
  updatedAt: attr('date'),
  deletedAt: attr('date'),
  systemGenerated: attr('boolean'), // Designation for special "system-generated" threads.  Shouldn't have projects, assignments, etc.

  // Pseudo properties
  recipient: belongsTo('user', { async: false }), // This is only available on new thread creation and should never be relied upon
  unread: attr('boolean'),
  lastReadAt: attr('date'),
  archivedAt: attr('date'),
  watchedBy: attr(),

  etc: attr(),

  // Relationships
  messages: hasMany('message', { async: false }),
  users: hasMany('user', { async: false }),
  threadUsers: hasMany('threadUser', { async: false }),
  assignment: belongsTo('assignment', { async: false }),
  applications: hasMany('application', { async: false }),

  // Custom Endpoints
  archive: memberAction({path: 'archive', type: 'post'}),
  unarchive: memberAction({path: 'unarchive', type: 'post'}),
  markRead: memberAction({path: 'mark-read', type: 'post'}),
  markUnread: memberAction({path: 'mark-unread', type: 'post'}),
  addUsers: memberAction({path: 'relationships/users', type: 'post'}),
  removeUsers: memberAction({path: 'relationships/users', type: 'delete'}),
  search: collectionAction({path: 'search', type: 'post'}),

  lastMessageMeta: computed(
    'lastBuyerMessagePreview',
    'lastBuyerMessageAt',
    'lastSellerMessagePreview',
    'lastSellerMessageAt',
    function () {
      const buyerTuple = [this.lastBuyerMessageAt, this.lastBuyerMessagePreview];
      const sellerTuple = [this.lastSellerMessageAt, this.lastSellerMessagePreview];

      const [newest] = [buyerTuple, sellerTuple]
        .filter(([date]) => date != null)
        .sort(([lhs], [rhs]) => {
          if (lhs < rhs) {
            return 1;
          } else if (lhs > rhs) {
            return -1;
          } else {
            return 0;
          }
        });

      const date = newest?.[0];
      const preview = newest?.[1];

      return {
        date: date ? new Date(date) : null,
        preview: preview ?? '',
      };
    },
  ),

  lastMessagePreview: readOnly('lastMessageMeta.preview'),
  lastMessageDate: readOnly('lastMessageMeta.date'),

  lastMessage: computed('messages.@each.createdAt', function () {
    let messages = Array.isArray(this.messages)
      ? this.messages
      : this.messages.toArray();

    if (messages.length) {
      [...messages].sort((a, b) => {
        if (a.createdAt < b.createdAt) {
          return -1;
        } else if (a.createdAt > b.createdAt) {
          return 1;
        } else {
          return 0;
        }
      });

      return messages[messages.length - 1].body;
    } else {
      return '';
    }
  })
});
